import { getBusinessConfig } from "@web/config/business-config";

function validDate(value: string | Date) {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.valueOf()) ? null : date;
}

export function businessDateKey(value: string | Date) {
  const date = validDate(value);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: getBusinessConfig().timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value || "";
  return `${part("year")}-${part("month")}-${part("day")}`;
}

export function formatBusinessDate(
  value: string | Date,
  options: Intl.DateTimeFormatOptions = {},
) {
  const date = validDate(value);
  if (!date) return "—";
  return new Intl.DateTimeFormat("en-AE", {
    timeZone: getBusinessConfig().timezone,
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...options,
  }).format(date);
}

export function formatBusinessTime(
  value: string | Date,
  options: Intl.DateTimeFormatOptions = {},
) {
  const date = validDate(value);
  if (!date) return "—";
  return new Intl.DateTimeFormat("en-AE", {
    timeZone: getBusinessConfig().timezone,
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  }).format(date);
}

export function formatBusinessDateTime(
  value: string | Date,
  options: Intl.DateTimeFormatOptions = {},
) {
  const date = validDate(value);
  if (!date) return "—";
  return new Intl.DateTimeFormat("en-AE", {
    timeZone: getBusinessConfig().timezone,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  }).format(date);
}

export function businessDateStartUtc(value: string) {
  return new Date(`${value}T00:00:00${getBusinessConfig().utcOffset}`).toISOString();
}

export function businessDateEndExclusiveUtc(value: string) {
  return new Date(
    new Date(`${value}T00:00:00${getBusinessConfig().utcOffset}`).valueOf() + 86_400_000,
  ).toISOString();
}

export function businessDateTimeToUtc(value: string) {
  return new Date(`${value}:00${getBusinessConfig().utcOffset}`).toISOString();
}

export function toBusinessDateTimeInput(value: string) {
  const date = validDate(value);
  if (!date) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: getBusinessConfig().timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value || "";
  return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
}
